// extracted by mini-css-extract-plugin
export default {"container":"TextBoxDocumentation_container__gVOmR","propertyDivider":"TextBoxDocumentation_propertyDivider__y5bQq","warning":"TextBoxDocumentation_warning__ncjWN"};